import { createContext, ReactNode, useContext, useState } from 'react';

interface IntegrationWarningContextType {
  isVisible: boolean;
  showWarning: () => void;
  hideWarning: () => void;
}

const IntegrationWarningContext = createContext<
  IntegrationWarningContextType | undefined
>(undefined);

export const IntegrationWarningProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const showWarning = () => setIsVisible(true);
  const hideWarning = () => setIsVisible(false);

  return (
    <IntegrationWarningContext.Provider
      value={{ isVisible, showWarning, hideWarning }}
    >
      {children}
    </IntegrationWarningContext.Provider>
  );
};

export const useIntegrationWarning = () => {
  const ctx = useContext(IntegrationWarningContext);
  if (!ctx)
    throw new Error(
      'useIntegrationWarning must be used within IntegrationWarningProvider'
    );
  return ctx;
};
